import React from "react";
import { map, values } from "ramda";

import Chip from "@material-ui/core/Chip";
import FacetPillLabel from "./FacetPillLabel";

const FacetPills = ({ facetPills, handleClearFacet, handleClick }) => {
  return map(
    facet => (
      <Chip
        key={"facet-" + facet.name}
        id={"facet-pill-" + facet.name}
        label={<FacetPillLabel facet={facet} />}
        onClick={() => handleClick(facet.name)}
        onDelete={() => handleClearFacet(facet)}
        variant="outlined"
      />
    ),
    values(facetPills),
  );
};

export default FacetPills;
